export default class Filter {
    constructor(predicates, operator = 'AND') {
        this.children = predicates;
        this.operator = operator;
        this.type = 'complex';
    }
}
